import axios from '../utils/axios';

export default function updateRecruiterCompany(adminId, companyId, data) {
    return (
        axios.post('/admin/' + adminId + '/recruiter-company-list/' + companyId,  data )

    )
}
